import { render, staticRenderFns } from "./DropsView.vue?vue&type=template&id=8ffd5d04&scoped=true&"
import script from "./DropsView.vue?vue&type=script&lang=js&"
export * from "./DropsView.vue?vue&type=script&lang=js&"
import style0 from "./DropsView.vue?vue&type=style&index=0&id=8ffd5d04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ffd5d04",
  null
  
)

export default component.exports